import { hasAnyAnswer } from "../performanceUtils";
import EvaluationForm from "../form/EvaluationForm";
import ScoreSummary from "./ScoreSummary";

// Read-only results: score summary plus every answer, with the employee's
// self-ratings alongside when a self-assessment was done.
const EvaluationResults = ({ evaluation }) => {
  const showSelf =
    evaluation.template?.allowSelfAssessment &&
    hasAnyAnswer(evaluation.selfResponses);

  return (
    <>
      <ScoreSummary scores={evaluation.scores} />
      <EvaluationForm
        sections={evaluation.sections}
        responses={evaluation.responses}
        selfResponses={showSelf ? evaluation.selfResponses : undefined}
      />
    </>
  );
};

export default EvaluationResults;
